import axios from 'axios';
const { get } = axios.create();

// export function getLocales() {
//   return get('/locales');
// }

// export function getLanguage(lang) {
//   // TODO: 规范确定后把文件夹名称改掉
//   const api = `${process.env.MOUNT_BASE}languages/${lang.replace(/_/, '-')}`;
//   return axios.all([
//     axios.get(`${api}/main.json`, { params: { _: +new Date() } }),
//     axios.get(`${api}/element.json`),
//   ]).then(axios.spread((main, element) => (
//     Object.assign({}, main.data, element.data)
//   )));
// }

export function getLanguage(lang) {
  return axios.get(`/static/i18n/${lang}/main.json`);
}



// WEBPACK FOOTER //
// ./src/api/getData.js